import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LogButtonEventToGA } from '../../components/sharedComponents/googleAnalytics/GoogleAnalytics';

export interface ModalProps {
  openDeleteModal: boolean;
  closeDeleteModal: () => void;
  modalAPi: () => void;
  dialogTitle: string;
  textContent: string;
  confirmButtonText: string;
  placeHolder?: string;
}

const DeleteModal: React.FC<ModalProps> = ({
  openDeleteModal,
  closeDeleteModal,
  modalAPi,
  dialogTitle,
  textContent,
  confirmButtonText,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      fullWidth
      sx={{ borderRadius: '4px' }}
      open={openDeleteModal}
      onClose={closeDeleteModal}
      aria-labelledby="responsive-dialog-title"
    >
      <Box padding={'20px 40px'}>
        <DialogTitle id="responsive-dialog-title" textAlign={'center'}>
          <Typography fontSize={24} fontWeight={700}>
            {dialogTitle}
          </Typography>
          <Divider sx={{ padding: '10px' }} aria-hidden="true" />
        </DialogTitle>

        <DialogContent>
          <DialogContentText textAlign={'center'} color={'#505050'} id="delete-modal-description" tabIndex={0}>
            {textContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ textTransform: 'none', textDecoration: 'underline' }}
            autoFocus
            size="small"
            onClick={() => {
              LogButtonEventToGA(t('rightPanel.cancel'));
              closeDeleteModal();
            }}
          >
            {t('rightPanel.cancel')}
          </Button>
          <Button
            sx={{ textTransform: 'none', backgroundColor: '#B91C1B' }}
            variant="contained"
            color="error"
            size="small"
            onClick={() => modalAPi()}
            autoFocus
          >
            {confirmButtonText}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default DeleteModal;
